import { useContext } from "react";
import { Icon } from "@iconify/react";
import { TextsContext } from "context/textsContext";
import DialogComponent from "./DialogComponent";
import { ParagraphComponent } from "./ParagraphComponent";

/**
 * Modal de "cambios sin guardar" reutilizable: solo la UI. Quien lo use aporta
 * `show` y las acciones (`onConfirm` para salir, `onCancel` para quedarse) -
 * así lo puede montar tanto un form con guard propio (My Favorite Plan) como
 * uno que solo confirma una acción puntual (Back to Home del cotizador).
 */
const UnsavedChangesModal = ({ show, onConfirm, onCancel }) => {
    const { texts } = useContext(TextsContext);

    return (
        <DialogComponent
            show={show}
            onClose={onCancel}
            onCancel={onCancel}
            onConfirm={onConfirm}
            cancelText={texts?.favorite_plan_form_stay ?? 'Stay'}
            confirmText={texts?.favorite_plan_form_leave ?? 'Leave'}
        >
            <Icon icon="fluent:alert-12-regular" width={40} height={40} style={{ color: '#F12B24' }} className="mb-3" />
            <ParagraphComponent styleGroup="raleway color_primary mb-0">
                {texts?.favorite_plan_form_unsaved_changes_message
                    ?? 'You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.'}
            </ParagraphComponent>
        </DialogComponent>
    );
};

export default UnsavedChangesModal;
